import { Validator } from "./Validator";

export class DomainValidator  extends Validator
{
  validate( value:string )
  {
    if ( value.indexOf( "@" ) !== -1 )
    {
      this.error( "Can't have an @ in domain: " + value );
      return false;
    }

    if (  value.indexOf( ".." ) != -1 )
    {
      this.error( "Can't have double dots in domain: " + value );
      return false;
    }

    let labels = value.split( "." );

    for ( let label of labels )
    {
      if ( ! this.validateLabel( label ) )
      {
        this.error( "Invalid label: "+ label + " in domain: " + value);
        return false;
      }
    }
    
    return true;

  }

  validateLabel( label:string )
  {    
    let regex = /^[a-zA-Z0-9-_]+$/;
    return regex.test( label );    
  } 
}